import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["inputWidth"];
import React, { Suspense } from 'react';
import { SearchDialog } from '@atlassian/search-dialog';
import { ResolvedAndErrorContent } from './resolved-and-error-content';
import { SearchSkeletons } from './search-skeletons';
export var SearchDropdown = function SearchDropdown(_ref) {
  var inputWidth = _ref.inputWidth,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SearchDialog
  /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */, {
    style: {
      boxShadow: 'none',
      width: inputWidth
    }
    /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(SearchSkeletons, null)
  }, /*#__PURE__*/React.createElement(ResolvedAndErrorContent, props)));
};